/* Classical Coffee — theme behavior
   Vanilla JS, no dependencies. Uses Shopify AJAX Cart API. */
(function () {
  "use strict";

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) =>
    (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.themeMoneyFormat)
      : "$" + (cents / 100).toFixed(2);
  const a11yStatus = $("[data-a11y-status]");
  const setStatus = (msg) => { if (a11yStatus) a11yStatus.textContent = msg; };

  /* ---------- Overlay + panels ---------- */
  const overlay = $("[data-overlay]");
  function openPanel(el) {
    if (!el) return;
    el.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      el.classList.add("is-open");
      overlay.classList.add("is-open");
    });
    document.body.style.overflow = "hidden";
  }
  function closePanels() {
    $$(".drawer.is-open, .mobile-menu.is-open").forEach((el) => {
      el.classList.remove("is-open");
      setTimeout(() => (el.hidden = true), 380);
    });
    overlay.classList.remove("is-open");
    setTimeout(() => (overlay.hidden = true), 320);
    document.body.style.overflow = "";
  }
  if (overlay) overlay.addEventListener("click", closePanels);
  document.addEventListener("keydown", (e) => e.key === "Escape" && closePanels());
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-close-panel]");
    if (t) { e.preventDefault(); closePanels(); }
  });

  /* ---------- Mobile menu ---------- */
  $$("[data-menu-open]").forEach((b) =>
    b.addEventListener("click", () => openPanel($(".mobile-menu")))
  );

  /* ---------- Cart drawer ---------- */
  const drawer = $("#CartDrawer");
  const cartCountEls = $$("[data-cart-count]");
  const cartType = document.body.dataset.cartType || "drawer";

  function updateCartCount(count) {
    cartCountEls.forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    const body = $("[data-drawer-body]", drawer);
    const foot = $("[data-drawer-foot]", drawer);
    if (!cart.items.length) {
      body.innerHTML =
        '<div class="cart-empty"><p>' +
        (window.themeStrings?.cartEmpty || "Your cart is empty.") +
        '</p><a class="btn btn--gold" href="/collections/all">' +
        (window.themeStrings?.cartEmptyCta || "Start with a roast") +
        "</a></div>";
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items
      .map(
        (it, i) => `
      <div class="cart-line" data-line="${i + 1}">
        <img class="cart-line__img" src="${it.image ? it.image.replace(/(\.[^.]+)(\?|$)/, "_120x150_crop_center$1$2") : ""}" alt="" loading="lazy">
        <div>
          <a class="cart-line__title" href="${it.url}">${it.product_title}</a>
          ${it.variant_title && it.variant_title !== "Default Title" ? `<div class="cart-line__variant">${it.variant_title}</div>` : ""}
          <div class="qty" style="margin-top:8px">
            <button type="button" data-qty="-1" aria-label="Decrease">&minus;</button>
            <input type="text" value="${it.quantity}" data-qty-input readonly aria-label="Quantity">
            <button type="button" data-qty="1" aria-label="Increase">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="cart-line__title">${money(it.final_line_price)}</div>
          <button class="cart-line__remove" data-remove>${window.themeStrings?.remove || "Remove"}</button>
        </div>
      </div>`
      )
      .join("");
    $("[data-subtotal]", drawer).textContent = money(cart.total_price);
  }

  async function getCart() {
    const r = await fetch("/cart.js");
    return r.json();
  }
  async function changeLine(line, quantity) {
    const r = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    return r.json();
  }

  async function refreshDrawer(open) {
    const cart = await getCart();
    updateCartCount(cart.item_count);
    renderDrawer(cart);
    if (open && cartType === "drawer") openPanel(drawer);
  }

  // open cart
  $$("[data-cart-open]").forEach((b) =>
    b.addEventListener("click", (e) => {
      if (cartType === "drawer") { e.preventDefault(); refreshDrawer(true); }
    })
  );

  // drawer interactions (qty + remove)
  if (drawer) {
    drawer.addEventListener("click", async (e) => {
      const line = e.target.closest("[data-line]");
      if (!line) return;
      const idx = parseInt(line.dataset.line, 10);
      const input = $("[data-qty-input]", line);
      let q = parseInt(input.value, 10);
      if (e.target.matches("[data-remove]")) q = 0;
      else if (e.target.matches("[data-qty]")) q += parseInt(e.target.dataset.qty, 10);
      else return;
      const cart = await changeLine(idx, Math.max(0, q));
      updateCartCount(cart.item_count);
      renderDrawer(cart);
      setStatus("Cart updated.");
    });
  }

  /* ---------- Add to cart (forms) ---------- */
  $$("form[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = $("[type=submit]", form);
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding…";
      setStatus("Adding to cart…");
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error("add failed");
        await refreshDrawer(true);
        btn.textContent = "Added ✓";
        setStatus("Added to cart.");
        setTimeout(() => (btn.textContent = label), 1400);
      } catch (err) {
        btn.textContent = "Try again";
        setStatus("Could not add to cart. Please try again.");
        setTimeout(() => (btn.textContent = label), 1600);
      } finally {
        btn.disabled = false;
      }
    });
  });

  /* ---------- Product: variants + gallery ---------- */
  $$("[data-product-root]").forEach((root) => {
    let variants = [];
    try { variants = JSON.parse($("[data-variants]", root).textContent); } catch (e) {}
    const idInput = $("[data-variant-id]", root);
    const priceEl = $("[data-price]", root);
    const addBtn = $("[data-add-btn]", root);
    const selected = {};

    function findVariant() {
      const opts = Object.keys(selected).sort().map((k) => selected[k]);
      return variants.find((v) =>
        v.options.every((o, i) => o === selected["option" + (i + 1)])
      );
    }
    function apply() {
      const v = findVariant();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = money(v.price) +
          (v.compare_at_price > v.price ? ` <del>${money(v.compare_at_price)}</del><span class="badge-sale">Sale</span>` : "");
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (window.themeStrings?.addToCart || "Add to cart") : (window.themeStrings?.soldOut || "Sold out");
      }
    }

    $$("[data-option]", root).forEach((group) => {
      const opt = group.dataset.option;
      const active = $(".swatch.is-active", group);
      if (active) selected[opt] = active.dataset.value;
      group.addEventListener("click", (e) => {
        const sw = e.target.closest(".swatch");
        if (!sw) return;
        $$(".swatch", group).forEach((s) => { s.classList.remove("is-active"); s.setAttribute("aria-pressed", "false"); });
        sw.classList.add("is-active");
        sw.setAttribute("aria-pressed", "true");
        selected[opt] = sw.dataset.value;
        apply();
      });
    });
    apply();

    // gallery thumbs
    const mainImg = $("[data-main-img]", root);
    $$("[data-thumb]", root).forEach((t) =>
      t.addEventListener("click", () => {
        $$("[data-thumb]", root).forEach((x) => x.classList.remove("is-active"));
        t.classList.add("is-active");
        if (mainImg) { mainImg.src = t.dataset.full; mainImg.srcset = ""; }
      })
    );
  });

  /* ---------- Scroll reveal ---------- */
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      }),
      { rootMargin: "0px 0px -8% 0px" }
    );
    $$(".fade-up").forEach((el) => {
      const sibs = $$(":scope > .fade-up", el.parentElement || document.body);
      const i = sibs.indexOf(el);
      if (i > 0) el.style.transitionDelay = Math.min(i * 70, 350) + "ms";
      io.observe(el);
    });
  } else {
    $$(".fade-up").forEach((el) => el.classList.add("in"));
  }

  /* ---------- Fundraiser earnings calculator ---------- */
  const calcFamilies = $("#calcFamilies");
  if (calcFamilies) {
    const calcBags = $("#calcBags");
    const famOut = $("#calcFamiliesOut");
    const bagsOut = $("#calcBagsOut");
    const result = $("#calcResult");
    const PROFIT_PER_BAG = 5;
    const updateCalc = () => {
      const fam = parseInt(calcFamilies.value, 10) || 0;
      const bags = calcBags ? (parseInt(calcBags.value, 10) || 0) : 2;
      const annual = fam * bags * 12 * PROFIT_PER_BAG;
      if (famOut) famOut.textContent = fam.toLocaleString("en-US");
      if (bagsOut) bagsOut.textContent = bags;
      if (result) result.textContent = "$" + annual.toLocaleString("en-US");
    };
    calcFamilies.addEventListener("input", updateCalc);
    if (calcBags) calcBags.addEventListener("input", updateCalc);
    updateCalc();
  }

  /* ---------- Init cart count on load ---------- */
  getCart().then((c) => updateCartCount(c.item_count)).catch(() => {});
})();
